import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../ui/Modal';

interface DiscardChangesModalProps {
  onDiscard: () => void;
  onKeepEditing: () => void;
}

const DiscardChangesModal: React.FC<DiscardChangesModalProps> = ({
  onDiscard,
  onKeepEditing,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen
      onClose={onKeepEditing}
      title={t('shipment_discard_title')}
      hideCloseButton
      className="shipment-tracker-modal shipment-tracker-modal--confirm"
    >
      <p>{t('shipment_discard_body')}</p>
      <div className="shipment-tracker-modal__footer">
        <button
          type="button"
          className="shipment-tracker-modal__btn shipment-tracker-modal__btn--secondary"
          onClick={onDiscard}
        >
          {t('shipment_discard_confirm')}
        </button>
        <button
          type="button"
          className="shipment-tracker-modal__btn shipment-tracker-modal__btn--primary"
          onClick={onKeepEditing}
        >
          {t('shipment_discard_keep')}
        </button>
      </div>
    </Modal>
  );
};

export default DiscardChangesModal;
